
    <div fxLayout="column" class="full-height" fxLayoutAlign="center center">
      <div class="mat-display-1">
        {{ 'change password' | translate | titlecase }}
      </div>
      <form
        [formGroup]="form"
        fxLayout="column"
        fxLayoutAlign="space-around center"
        class="full-width"
      >
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'password' | translate | titlecase }}</mat-label>
          <input
            matInput
            formControlName="password"
            [type]="hidePassword ? 'password' : 'text'"
          />
          <mat-icon
            matSuffix
            (click)="$event.stopPropagation(); hidePassword = !hidePassword"
            style="cursor: pointer"
            svgIcon="{{ hidePassword ? 'visibility' : 'visibility_off' }}"
          >
          </mat-icon>
          <mat-error *ngIf="password.hasError('required')"
            >{{ 'password' | translate | titlecase }} {{ 'is' | translate }}
            {{ 'required' | translate }}</mat-error
          >
          <mat-error *ngIf="password.getError('minlength')"
            >{{
              'password should have at least length 6'
                | translate
                | sentancecase
            }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{
            'confirm password' | translate | titlecase
          }}</mat-label>
          <input
            matInput
            formControlName="confirmPassword"
            [type]="hideConfirmPassword ? 'password' : 'text'"
          />
          <mat-icon
            matSuffix
            (click)="
              $event.stopPropagation();
              hideConfirmPassword = !hideConfirmPassword
            "
            style="cursor: pointer"
            svgIcon="{{
              hideConfirmPassword ? 'visibility' : 'visibility_off'
            }}"
          >
          </mat-icon>
          <mat-error *ngIf="confirmPassword.getError('required')"
            >{{ 'confirm password' | translate | sentancecase }}
            {{ 'is' | translate }} {{ 'required' | translate }}
          </mat-error>
          <mat-error *ngIf="confirmPassword.getError('matchPassword')"
            >{{ 'passwords do not match' | translate | sentancecase }}
          </mat-error>
          <mat-error *ngIf="confirmPassword.getError('minlength')"
            >{{
              'password should have at least length 6'
                | translate
                | sentancecase
            }}
          </mat-error>
        </mat-form-field>
        <ml-loading-button
          class="full-width"
          [name]="'confirm'"
          [loading]="loading"
          [disabled]="loading || !form.valid"
          (press)="onChangePassword()"
        >
        </ml-loading-button>
      </form>
    </div>
  